import urls from '../api_urls/accounts'
import { _post, _upload } from '@/axios/request'
import $axios from '@/axios/config.js'
// 获取用户列表
export function getTableData (params) {
  return _post(urls.GET_USER_LIST, params)
}

// 获取角色列表
export function getRoleData () {
  return _post(urls.GET_ROLE_LIST)
}

// 新增保存用户
export function saveUser (params) {
  return _post(urls.SAVE_USER, params)
}

// 获取用户详情
export function getUserDetail (params) {
  return _post(urls.GET_USER_DETAIL, params)
}

export function getUserCompanyDetail (params) {
  return _post(urls.GET_USER_COMPANY_DETAIL, params)
}

// 更新用户信息
export function updateUser (params) {
  return _post(urls.UPDATE_USER, params)
}

// 更新用户信息
export function updateUserCompany (params) {
  return _post(urls.UPDATE_USER_COMPANY, params)
}

// 重置密码
export function resetPassword (params) {
  return _post(urls.RESET_PASSWORD, params)
}

// 修改用户权限发邮件
export function changeAuth (params) {
  return _post(urls.CHANGE_AUTH, params)
}

// 获取默认free角色
export function getDefaultRole () {
  return _post(urls.GET_DEFAULT_ROLE)
}

// 注销
export function deregistration (params) {
  return _post(urls.DEREGISTRATION, params)
}

export function getInactiveList (params) {
  return _post(urls.GET_INACTIVE_LIST, params)
}

// 批量设置角色
export function setRole (params) {
  return _post(urls.MASS_SET_ROLE, params)
}

// 批量编辑用户
export function setAccounts (params) {
  return _post(urls.MASS_SET_ACCOUNT, params)
}

// 账号解析
export function analysisAccount (params) {
  return _post(urls.ANALYSIS_ACCOUNT, params)
}

// 删除角色
export function deleteRoles (params) {
  return _post(urls.DELETE_ROLES, params)
}

// 激活日志列表
export function getRegisterList (params) {
  return _post(urls.REGISTER_LIST, params)
}

// 获取user company列表
export function getUserCompanyList (params) {
  return _post(urls.USER_COMPANY_LIST, params)
}

// 激活日志导出
export function registerExport (params) {
  return _post(urls.REGISTER_EXPORT, params)
}

// 管理后台激活
export function manageActivate (params) {
  return _post(urls.MANAGE_ACTIVATE, params)
}
// 下载
export function downloadFile (params) {
  return $axios({
    url: urls.DOWNLOAD,
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}
export function getFileFlow (params) {
  return $axios({
    url: urls.GET_FILE_FLOW,
    method: 'get',
    params,
    responseType: 'arraybuffer'
  })
}
// 删除user company
export function delUserCompany (params) {
  return _post(urls.DEL_USER_COMPANY, params)
}

// 导入
export function uploadFile (params) {
  console.log(params)
  return _upload(urls.UPLOAD, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/accounts.js